export const appsTransformationTemplatesDatatable = "/apps/transformation_templates_datatable";
